export default __webpack_public_path__ + "static/media/ic_access_practice.fd5755a6.svg";